// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Link, useParams } from 'react-router-dom';
import { FilePond, registerPlugin } from "react-filepond";
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Modal, Button } from "react-bootstrap";
// CUSTOM COMPONENTS
import * as jobUploadFormService from "../../../../services/form/jobUploadFormService";
import * as jobFormService from "../../../../services/service/jobFormService";
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as helper from "../../../../helpers/helper";
import constants from "../../../../constants/constants";
import set from 'date-fns/set';
import { SignalCellularNullOutlined } from '@material-ui/icons';
//STYLES AND ASSETS

const JobUploadForm = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history } = props;
    const { jobFormId } = useParams();
    const [loading, setLoading] = useState(false);
    const [renameModalVisible, setRenameModalVisible] = useState(false);
    const [renameModel, setRenameModel] = useState({ jobUploadFormId: 0, name: '' })
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobUploadForm: {
            id: 0,
            filePath: '',
            jobUploadFormAttachments: []
        },
        actualAssignedDate: '',
        submittedById: SignalCellularNullOutlined
    });

    useEffect(() => {
        fetchFormData();
    }, [])

    const fetchFormData = () => {
        setLoading(true);
        jobUploadFormService.getUploadForm(jobFormId).then(res => {
            if (res) {
                setJobForm(res);
                setIsReadOnly(res.submittedById !== null);
            }
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const deleteAttachment = (id) => {
        setLoading(true);
        setProcessing();
        jobUploadFormService.deleteFormAttachment(id).then(res => {
            fetchFormData();
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            setLoading(false);
            hideConfirmModal();
        });
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <a
                                target="_blank"
                                href={constants.API_URL + jobForm.jobUploadForm.jobUploadFormAttachments[dataIndex].attachmentPath}
                                className="btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5"
                            >
                                View
                            </a> &nbsp;
                            {
                                !isReadOnly &&
                                <>
                                    <button
                                        href="#"
                                        className="btn btn-sm btn-warning font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => {
                                            let currentAttachment = jobForm.jobUploadForm.jobUploadFormAttachments[dataIndex];

                                            setRenameModel({ jobUploadFormId: currentAttachment.id, name: currentAttachment.name });
                                            setRenameModalVisible(true);
                                        }}
                                    >
                                        Rename
                                    </button> &nbsp;
                                    <button
                                        href="#"
                                        className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => showConfirmModal({
                                            title: "Delete Form",
                                            text: "Are you sure you want to delete this uploaded form?",
                                            rightBtnText: "Confirm",
                                            btnAction: () => deleteAttachment(jobForm.jobUploadForm.jobUploadFormAttachments[dataIndex].id)
                                        })}
                                    >
                                        Delete
                                    </button>
                                </>
                            }
                        </>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "fileSize",
            label: "File Size",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "extension",
            label: "Extension",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ];

    const renameFileAndCloseModal = () => {
        if (renameModel.name === "" || renameModel.jobUploadFormId === 0)
            return;

        jobUploadFormService.renameFormAttachment(renameModel).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            fetchFormData();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            handleRenameModalClose();
        })
    }

    const uploadFilesAndCloseModal = () => {
        if (uploadedFile.length == 0)
            return;

        jobUploadFormService.saveUploadForm(helper.convertJsonToFormData({ jobUploadFormId: jobForm.jobUploadForm.id, files: uploadedFile ? uploadedFile.map(x => x.file) : null })).then(res => {
            showAlert({ message: res.message, variant: 'success' });

            fetchFormData();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            handleUploadModalClose();
        })
    }

    const handleRenameModalClose = () => {
        setRenameModel({ jobUploadFormId: 0, name: '' });
        setRenameModalVisible(false);
    }

    const handleUploadModalClose = () => {
        setUploadedFile([]);
        setUploadModalVisible(false);
    }

    const completeUploadForm = () => {
        setProcessing();
        jobFormService.submitForm(jobForm.id).then(res => {
            showAlert({ message: "Success! Upload Form has been submitted.", variant: 'success' });
            hideConfirmModal();
            history.push('/services/manage-job/forms/' + jobForm.jobId);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        })
    }

    return (
        <div className="card card-custom card-stretch">
            {loading && <ModalProgressBar />}
            <Modal centered size="lg" show={renameModalVisible} onHide={handleRenameModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Rename Attachment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form">
                        <div className="card-body">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Name
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid`}
                                            name="name"
                                            value={renameModel.name}
                                            onChange={(e) => setRenameModel({ ...renameModel, name: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleRenameModalClose}>
                        Close
                    </Button>
                    <button
                        type="submit"
                        className="btn btn-success mr-2"
                        onClick={renameFileAndCloseModal}
                    >
                        Save
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal centered size="lg" show={uploadModalVisible} onHide={handleUploadModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Attachments</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FilePond
                        allowMultiple={true}
                        labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                        onupdatefiles={setUploadedFile}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleUploadModalClose}>
                        Close
                    </Button>
                    <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        onClick={() => uploadFilesAndCloseModal()}
                    >
                        Upload
                    </button>
                </Modal.Footer>
            </Modal>
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Upload Form ({jobForm.name} / {moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")})
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        Please download the upload form and start filling out the form
                    </span>
                </div>
                <div className="card-toolbar">
                    {
                        !isReadOnly &&
                        <button
                            type="submit"
                            className={`btn btn-success mr-2`}
                            onClick={() => showConfirmModal({
                                title: "Submit Form",
                                text: "Are you sure you want to submit this form? Once submitted this form will be read-only.",
                                rightBtnText: "Confirm",
                                btnAction: () => completeUploadForm()
                            })}
                        >
                            Submit Form
                        </button>
                    }
                    <Link
                        to={"/services/manage-job/forms/" + jobForm.jobId}
                        className="btn btn-danger"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <div className="form">
                <div className="card-body">
                    <a className="btn btn-info" target="_blank" href={constants.API_URL + jobForm.jobUploadForm?.filePath ?? ''}>Download Form</a> &nbsp;
                    {
                        !isReadOnly &&
                        <button className="btn btn-primary" onClick={() => setUploadModalVisible(true)}>Upload Form</button>
                    }
                    <br />
                    <MUIDataTable
                        data={jobForm.jobUploadForm?.jobUploadFormAttachments}
                        columns={columns}
                        options={{
                            selectableRows: 'none',
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default connect(null, {
    ...alert.actions,
    ...confirmModal.actions
})(JobUploadForm);